export const toTranslateAudoVideoFormats = (value, t) => {
  if (value === "probably") {
    return t(`global.${value}`);
  }
  return value;
};
